<section class="testimonial-section section">
    <div class="container">
        <div class="section-title">
            <h2>Client Testimonial</h2>
        </div>
        <div class="testimonial-wrapper">
            <!-- <owl-carousel-o [options]="customOptions">
                <ng-template carouselSlide *ngFor="let testimonial of testimonialArray.clientList;">
                    <div class="testimonial-slide">
                        <div class="client-image">
                            <img [src]="testimonial.img">
                        </div>

                        <div class="client-info">
                            <h3 class="company-name">{{testimonial.company}}</h3>
                            <p class="testimonial-text">{{testimonial.description}}</p>
                            <p class="client-name">{{testimonial.name}}</p>
                            <p class="client-designation">{{testimonial.designation}}</p>
                        </div>
                    </div>
                </ng-template>
            </owl-carousel-o> -->
        </div>
    </div>
</section>